import parents from './parents';

const site_name = window.location.hostname;
document.addEventListener("DOMContentLoaded", function (event) {
    function getCookie(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : 'empty';
    }

    let referrer = document.referrer;
    let cookie_now = getCookie('utm');
    let url = window.location.href;
    let utm = '';
    let utm_default = '?utm_source=direct&utm_medium=none&utm_campaign=direct';
    let cookie_params = '; secure; samesite=strict; domain='+ site_name +'; path=/; max-age=3600';
    let i = 1;
    let referrer_utm = 'true';
    if (url.includes('?') && !!url.split('?')[1]) {
        let params = url.split('?')[1].split('&');
        if(params !== undefined) {
            params.forEach( function (el) {
                utm = (i == 1)?'?'+utm:utm;
                utm = utm + el + '&';
                i++;
            })
            referrer_utm = (utm != '')?'none':'';
        }
    }
    if (referrer_utm == 'true' && !!referrer.length && !referrer.includes(site_name)) {
        if (referrer.includes('google')) {
            utm = '?utm_source=google&utm_medium=organic&utm_campaign=organic';
        } else {
            let site = new URL(referrer);
            utm = '?utm_source=referral&utm_medium=referral&utm_campaign=' + site.hostname;
        }
    }

    if (utm != '') {
        document.cookie = 'utm=' + utm + cookie_params;
    } else if (cookie_now == 'empty') {
        document.cookie = 'utm=' + utm_default + cookie_params;
    }

    document.addEventListener('click', function (e) {
        let el = e.target;
        if ((el.tagName.toLowerCase() == 'a' || !!parents(el, 'a')[0]) && !!getCookie('utm')) {
            el = (parents(el, 'a')[0])?parents(el, 'a')[0]:el;
            let href = el.getAttribute('href');
            if (href.includes('//')) {
                let url = new URL(href);
                
                if (url.hostname == 'trk.credit-online.ua') {
                    e.preventDefault();
                    let utm = (href[href.length - 1] != '/') ? '/' + getCookie('utm') : getCookie('utm');
                    utm = (utm[utm.length - 1] != '&')?utm+'&':utm
                    href = href + utm + 'pg='+window.location.pathname;
                    window.location.href = href;
                }
            }
        }
    })
})
